export const fieldTranslations = {
  // DerivativeBarrier fields
  structured_product_id: "Id du produit structuré",
  structured_product_name: "Produit structuré",
  barrier_date: "Date d'observation",
  payment_date: "Date de paiement",
  coupon_value: "Valeur du coupon",
  coupon_barrier: "Barrière du coupon",
  capital_risk_barrier: "Barrière protection du capital",

  // Technical fields
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
